module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example-box"
  }, [_c('md-card', {
    staticClass: "example-box-card"
  }, [_c('md-toolbar', {
    staticClass: "md-dense",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.cardTitle))])]), _vm._v(" "), _c('md-card-area', [_c('md-tabs', {
    staticClass: "md-transparent example-tabs",
    attrs: {
      "md-right": "",
      "md-dynamic-height": false
    }
  }, [_c('md-tab', {
    staticClass: "example-content",
    attrs: {
      "md-label": "Demo",
      "md-active": ""
    }
  }, [_vm._t("demo")], 2), _vm._v(" "), _c('md-tab', {
    staticClass: "code-content",
    attrs: {
      "md-label": "Code"
    }
  }, [_vm._t("code")], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bb73e8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExampleBox.vue
// module id = 519
// module chunks = 83